module.exports = __webpack_public_path__ + "static/media/lena2.e26c5599.jpg";